export const translations = {
  en: {
    nav: {
      home: "Home",
      top10: "Top 10 dApps",
      top20: "Preferred dApps",
      sovereignNodes: "Sovereign Nodes",
      apply: "Apply",
      dashboard: "Dashboard",
      admin: "Admin"
    },
    hero: {
      badge: "We·R2 Builders Program — Open",
      headline: "Build the Next Generation of dApps on We·R2 Chain",
      subheadline: "Join the We·R2 Builders Program and develop one of the ecosystem's priority dApps. Access grants paid in WR2 Coin, revenue share models, technical support from We·R2 Chain and long-term co-creation.",
      cta_top10: "View Top 10 Strategic dApps",
      cta_proposal: "Submit a Proposal",
      cta_partner: "Apply as Development Partner",
      cta_nodes: "Explore Sovereign Nodes",
      stat_dapps: "Strategic dApps",
      stat_grants: "in WR2 Grants"
    },
    whyBuild: {
      headline: "Why Build on We·R2 Chain?",
      intro: "Sovereign blockchain infrastructure, EVM-compatible, 6,980 TPS and DMCC Licensed.",
      features: {
        lowCost: { title: 'Low transaction costs', desc: 'Gas fees in WR2 Coin — significantly cheaper than Ethereum mainnet thanks to PoA architecture.' },
        scalability: { title: 'High scalability', desc: '6,980 TPS · 6s/block · Chain ID 111888 · EVM PoA — verifiable on We·R2 Chain explorer.' },
        accountAbstraction: { title: 'Account abstraction', desc: 'Frictionless onboarding for non-crypto users via account abstraction.' },
        governance: { title: 'Governance', desc: 'BGT token + 151 Sovereign Nodes with 117,616 WR2 staked per node.' },
        realWorld: { title: 'Real-world integration', desc: 'On-chain RWA with Freedom Homes Club — real estate tokenization under DMCC Dubai compliance.' },
        community: { title: 'Active community', desc: '35,000+ early adopters in waitlist · growing ecosystem with Blonect, We·R2 Finance, We·R2 Pay and more.' },
      }
    },
    top10: {
      headline: "Top 10 Strategic dApps on We·R2 Chain – Critical Priority",
      subtext: "Essential applications for ecosystem growth, evaluated by the We·R2 technical committee. Grants paid in WR2 Coin.",
      applyBtn: "Apply to Build",
      impact: "Expected Impact",
      priority: "Priority",
      incentive: "Incentive Model",
      status: "Status"
    },
    top20: {
      headline: "Strategic Developments of the We·R2 Ecosystem",
      subtext: "High-impact dApps open for proposals. Evaluated by the We·R2 Ecosystem technical committee.",
      applyBtn: "Apply"
    },
    openProposals: {
      headline: "Propose Your Own dApp on We·R2 Chain",
      description: "Do you have an idea that fits the sovereign vision of We·R2 Ecosystem? Submit your proposal for review by the We·R2 technical committee. The best projects receive grants in WR2 Coin and access to 151 Sovereign Nodes.",
      cta: "Submit Proposal"
    },
    form: {
      headline: "Builder Application",
      teamInfo: "Team Information",
      teamName: "Team Name",
      country: "Country",
      website: "Website",
      github: "GitHub",
      linkedin: "LinkedIn",
      previousProjects: "Previous Web3 Projects",
      selectedDapp: "Selected dApp",
      selectPlaceholder: "Select a dApp or Custom Proposal",
      customProposal: "Custom Proposal",
      techArchitecture: "Technical Architecture",
      smartContract: "Smart Contract Design",
      scalability: "Scalability Strategy",
      securityPlan: "Security Plan",
      techStack: "Tech Stack",
      timeline: "Timeline",
      mvp: "MVP Date",
      beta: "Beta Date",
      mainnet: "Mainnet Date",
      incentivePref: "Incentive Preference",
      grant: "Grant",
      revenueShare: "Revenue Share",
      hybrid: "Hybrid",
      strategic: "Strategic Partnership",
      whyUni2: "Why We·R2 Chain?",
      fileUpload: "Upload Whitepaper or Deck",
      submit: "Submit Builder Application",
      submitting: "Submitting...",
      success: "Application submitted successfully!",
      error: "Error submitting application"
    },
    dashboard: {
      headline: "Ecosystem Development Tracker",
      inReview: "In Review",
      approved: "Approved",
      inDevelopment: "In Development",
      live: "Live",
      total: "Total Projects"
    },
    admin: {
      login: "Admin Login",
      password: "Password",
      loginBtn: "Login",
      logout: "Logout",
      proposals: "Proposals",
      updateStatus: "Update Status",
      viewDetails: "View Details"
    },
    categories: {
      gaming: "Gaming & Engagement",
      social: "Social Infrastructure",
      defi: "DeFi Infrastructure",
      lending: "Lending & Borrowing",
      payments: "Payments",
      nft: "NFT Utility",
      gamification: "Gamification",
      governance: "Governance",
      security: "Security",
      rwa: "Real World Assets",
      ai: "AI & ML",
      staking: "Staking",
      payroll: "Payroll",
      crosschain: "Cross-chain",
      data: "Data",
      insurance: "Insurance",
      creator: "Creator Economy",
      loyalty: "Loyalty",
      oracle: "Oracle",
      analytics: "Analytics",
      nocode: "No-Code",
      launchpad: "Launchpad",
      bridge: "Bridge",
      carbon: "Carbon Credits",
      supply: "Supply Chain",
      invoice: "Invoice",
      dao: "DAO"
    },
    statuses: {
      open: "Open for proposals",
      review: "In Review",
      approved: "Approved",
      development: "In Development",
      live: "Live"
    },
    incentives: {
      grant: "Grant (WR2 Coin)",
      revenueShare: "Revenue Share",
      grantRevenue: "Grant + Revenue Share",
      strategic: "Strategic Partnership"
    },
    hackathons: {
      title: "Hackathons",
      subtitle: "Join our hackathons and compete for WR2 Coin prizes while building on We·R2 Chain",
      upcoming: "Upcoming",
      active: "Active",
      completed: "Completed",
      registerNow: "Register Now",
      viewDetails: "View Details",
      prizes: "Prizes",
      tracks: "Tracks",
      participants: "Participants",
      deadline: "Registration Deadline",
      startDate: "Start Date",
      endDate: "End Date",
      requirements: "Requirements",
      registration: "Hackathon Registration",
      teamName: "Team Name",
      teamMembers: "Team Members",
      memberName: "Name",
      memberRole: "Role",
      memberGithub: "GitHub",
      addMember: "Add Team Member",
      selectTrack: "Select Track",
      projectIdea: "Project Idea",
      contactEmail: "Contact Email",
      registerTeam: "Register Team",
      registrationSuccess: "Successfully registered for hackathon!",
      registrationError: "Error registering for hackathon",
      statusUpcoming: "Upcoming",
      statusOpen: "Registration Open",
      statusActive: "Active",
      statusJudging: "Judging",
      statusCompleted: "Completed"
    },
    score: {
      title: "Builder Score",
      breakdown: "Score Breakdown",
      teamInfo: "Team Info",
      techArchitecture: "Technical Architecture",
      timeline: "Timeline",
      whyUni2: "Why We·R2",
      projectSelection: "Project Selection",
      high: "High Priority",
      medium: "Medium Priority",
      low: "Low Priority"
    },
    nda: {
      generate: "Generate NDA",
      download: "Download NDA",
      generated: "NDA Generated"
    },
    footer: {
      tagline: "Building the next generation of dApps on We·R2 Chain — EVM PoA, Chain ID 111888, DMCC Licensed."
    },
    sovereign: {
      headline: "Sovereign Nodes",
      subtext: "The backbone of We·R2 Chain — 151 distributed validators, each staking 117,616 WR2 Coin. Together they govern BGT proposals and secure the network.",
      stat_nodes: "Sovereign Nodes",
      stat_stake: "WR2 staked per node",
      stat_consensus: "Consensus",
      consensus: "EVM PoA",
      learnMore: "Learn more about Sovereign Nodes"
    }
  },
  es: {
    nav: {
      home: "Inicio",
      top10: "Top 10 dApps",
      top20: "dApps Preferidas",
      sovereignNodes: "Sovereign Nodes",
      apply: "Aplicar",
      dashboard: "Panel",
      admin: "Admin"
    },
    hero: {
      badge: "We·R2 Builders Program — Abierto",
      headline: "Construye la Próxima Generación de dApps en We·R2 Chain",
      subheadline: "Únete al We·R2 Builders Program y desarrolla una de las dApps prioritarias del ecosistema. Accede a grants en WR2 Coin, modelos de reparto de ingresos, soporte técnico de We·R2 Chain y co-creación a largo plazo.",
      cta_top10: "Ver Top 10 dApps Estratégicas",
      cta_proposal: "Enviar una Propuesta",
      cta_partner: "Aplicar como Partner de Desarrollo",
      cta_nodes: "Explorar Sovereign Nodes",
      stat_dapps: "dApps Estratégicas",
      stat_grants: "en WR2 Grants"
    },
    whyBuild: {
      headline: "¿Por qué Construir en We·R2 Chain?",
      intro: "Infraestructura blockchain soberana, EVM-compatible, con 6,980 TPS y licencia DMCC.",
      features: {
        lowCost: { title: 'Bajos costos de transacción', desc: 'Fees de gas en WR2 Coin, significativamente menores que Ethereum mainnet gracias a la arquitectura PoA.' },
        scalability: { title: 'Alta escalabilidad', desc: '6,980 TPS · 6s/block · Chain ID 111888 · EVM PoA — datos verificables en el We·R2 Chain explorer.' },
        accountAbstraction: { title: 'Abstracción de cuentas', desc: 'Onboarding sin fricción para usuarios no-cripto mediante account abstraction.' },
        governance: { title: 'Gobernanza', desc: 'Token BGT + 151 Sovereign Nodes con 117,616 WR2 stakeados por nodo.' },
        realWorld: { title: 'Integración mundo real', desc: 'RWA on-chain con Freedom Homes Club — tokenización inmobiliaria bajo cumplimiento DMCC Dubai.' },
        community: { title: 'Comunidad activa', desc: '35,000+ early adopters en waitlist · ecosistema con Blonect, We·R2 Finance, We·R2 Pay y más.' },
      }
    },
    top10: {
      headline: "Top 10 dApps Estratégicas en We·R2 Chain – Prioridad Crítica",
      subtext: "Aplicaciones esenciales para el crecimiento del ecosistema, evaluadas por el comité técnico de We·R2. Grants pagados en WR2 Coin.",
      applyBtn: "Aplicar para Construir",
      impact: "Impacto Esperado",
      priority: "Prioridad",
      incentive: "Modelo de Incentivos",
      status: "Estado"
    },
    top20: {
      headline: "Desarrollos Estratégicos del Ecosistema We·R2",
      subtext: "dApps de alto impacto abiertas a propuestas. Evaluadas por el comité técnico de We·R2 Ecosystem.",
      applyBtn: "Aplicar"
    },
    openProposals: {
      headline: "Propón Tu Propia dApp en We·R2 Chain",
      description: "¿Tienes una idea que encaja con la visión soberana de We·R2 Ecosystem? Envía tu propuesta para revisión por el comité técnico de We·R2. Los mejores proyectos reciben grants en WR2 Coin y acceso a 151 Sovereign Nodes.",
      cta: "Enviar Propuesta"
    },
    form: {
      headline: "Aplicación de Builder",
      teamInfo: "Información del Equipo",
      teamName: "Nombre del Equipo",
      country: "País",
      website: "Sitio Web",
      github: "GitHub",
      linkedin: "LinkedIn",
      previousProjects: "Proyectos Web3 Anteriores",
      selectedDapp: "dApp Seleccionada",
      selectPlaceholder: "Selecciona una dApp o Propuesta Personalizada",
      customProposal: "Propuesta Personalizada",
      techArchitecture: "Arquitectura Técnica",
      smartContract: "Diseño de Contrato Inteligente",
      scalability: "Estrategia de Escalabilidad",
      securityPlan: "Plan de Seguridad",
      techStack: "Stack Tecnológico",
      timeline: "Cronograma",
      mvp: "Fecha MVP",
      beta: "Fecha Beta",
      mainnet: "Fecha Mainnet",
      incentivePref: "Preferencia de Incentivos",
      grant: "Subvención",
      revenueShare: "Reparto de Ingresos",
      hybrid: "Híbrido",
      strategic: "Partnership Estratégica",
      whyUni2: "¿Por qué We·R2 Chain?",
      fileUpload: "Subir Whitepaper o Presentación",
      submit: "Enviar Aplicación de Builder",
      submitting: "Enviando...",
      success: "¡Aplicación enviada con éxito!",
      error: "Error al enviar la aplicación"
    },
    dashboard: {
      headline: "Rastreador de Desarrollo del Ecosistema",
      inReview: "En Revisión",
      approved: "Aprobados",
      inDevelopment: "En Desarrollo",
      live: "En Vivo",
      total: "Total de Proyectos"
    },
    admin: {
      login: "Acceso Admin",
      password: "Contraseña",
      loginBtn: "Entrar",
      logout: "Salir",
      proposals: "Propuestas",
      updateStatus: "Actualizar Estado",
      viewDetails: "Ver Detalles"
    },
    categories: {
      gaming: "Gaming y Engagement",
      social: "Infraestructura Social",
      defi: "Infraestructura DeFi",
      lending: "Préstamos",
      payments: "Pagos",
      nft: "Utilidad NFT",
      gamification: "Gamificación",
      governance: "Gobernanza",
      security: "Seguridad",
      rwa: "Activos del Mundo Real",
      ai: "IA y ML",
      staking: "Staking",
      payroll: "Nómina",
      crosschain: "Cross-chain",
      data: "Datos",
      insurance: "Seguros",
      creator: "Economía de Creadores",
      loyalty: "Lealtad",
      oracle: "Oracle",
      analytics: "Analíticas",
      nocode: "No-Code",
      launchpad: "Launchpad",
      bridge: "Bridge",
      carbon: "Créditos de Carbono",
      supply: "Cadena de Suministro",
      invoice: "Facturas",
      dao: "DAO"
    },
    statuses: {
      open: "Abierto para propuestas",
      review: "En Revisión",
      approved: "Aprobado",
      development: "En Desarrollo",
      live: "En Vivo"
    },
    incentives: {
      grant: "Subvención (WR2 Coin)",
      revenueShare: "Reparto de Ingresos",
      grantRevenue: "Subvención + Reparto",
      strategic: "Partnership Estratégica"
    },
    hackathons: {
      title: "Hackathons",
      subtitle: "Participa en nuestros hackathons y compite por premios en WR2 Coin mientras construyes en We·R2 Chain",
      upcoming: "Próximos",
      active: "Activos",
      completed: "Completados",
      registerNow: "Registrarse Ahora",
      viewDetails: "Ver Detalles",
      prizes: "Premios",
      tracks: "Categorías",
      participants: "Participantes",
      deadline: "Fecha Límite de Registro",
      startDate: "Fecha de Inicio",
      endDate: "Fecha de Fin",
      requirements: "Requisitos",
      registration: "Registro de Hackathon",
      teamName: "Nombre del Equipo",
      teamMembers: "Miembros del Equipo",
      memberName: "Nombre",
      memberRole: "Rol",
      memberGithub: "GitHub",
      addMember: "Agregar Miembro",
      selectTrack: "Seleccionar Categoría",
      projectIdea: "Idea del Proyecto",
      contactEmail: "Email de Contacto",
      registerTeam: "Registrar Equipo",
      registrationSuccess: "¡Registrado exitosamente en el hackathon!",
      registrationError: "Error al registrarse en el hackathon",
      statusUpcoming: "Próximo",
      statusOpen: "Registro Abierto",
      statusActive: "Activo",
      statusJudging: "En Evaluación",
      statusCompleted: "Completado"
    },
    score: {
      title: "Puntuación de Builder",
      breakdown: "Desglose de Puntuación",
      teamInfo: "Info del Equipo",
      techArchitecture: "Arquitectura Técnica",
      timeline: "Cronograma",
      whyUni2: "Por qué We·R2",
      projectSelection: "Selección de Proyecto",
      high: "Alta Prioridad",
      medium: "Media Prioridad",
      low: "Baja Prioridad"
    },
    nda: {
      generate: "Generar NDA",
      download: "Descargar NDA",
      generated: "NDA Generado"
    },
    footer: {
      tagline: "Building the next generation of dApps on We·R2 Chain — EVM PoA, Chain ID 111888, DMCC Licensed."
    },
    sovereign: {
      headline: "Sovereign Nodes",
      subtext: "La columna vertebral de We·R2 Chain — 151 validadores distribuidos, cada uno stakeando 117,616 WR2 Coin. Juntos gobiernan las propuestas BGT y aseguran la red.",
      stat_nodes: "Sovereign Nodes",
      stat_stake: "WR2 stakeados por nodo",
      stat_consensus: "Consenso",
      consensus: "EVM PoA",
      learnMore: "Conocer más sobre Sovereign Nodes"
    }
  },
  ru: {
    nav: {
      home: "Главная",
      top10: "Топ 10 dApps",
      top20: "Предпочтительные dApps",
      sovereignNodes: "Sovereign Nodes",
      apply: "Подать заявку",
      dashboard: "Панель",
      admin: "Админ"
    },
    hero: {
      badge: "We·R2 Builders Program — Открыта",
      headline: "Создайте следующее поколение dApps на We·R2 Chain",
      subheadline: "Присоединяйтесь к We·R2 Builders Program и разрабатывайте одно из приоритетных dApps экосистемы. Получите гранты в WR2 Coin, модели распределения доходов, техническую поддержку We·R2 Chain и долгосрочное сотрудничество.",
      cta_top10: "Посмотреть Топ 10 Стратегических dApps",
      cta_proposal: "Подать Предложение",
      cta_partner: "Подать заявку как Партнер по Разработке",
      cta_nodes: "Изучить Sovereign Nodes",
      stat_dapps: "Стратегических dApps",
      stat_grants: "в WR2 грантах"
    },
    whyBuild: {
      headline: "Почему стоит строить на We·R2 Chain?",
      intro: "Суверенная блокчейн-инфраструктура, EVM-совместимая, 6,980 TPS и лицензия DMCC.",
      features: {
        lowCost: { title: 'Низкие транзакционные издержки', desc: 'Комиссии в WR2 Coin — значительно дешевле Ethereum mainnet благодаря PoA архитектуре.' },
        scalability: { title: 'Высокая масштабируемость', desc: '6,980 TPS · 6s/блок · Chain ID 111888 · EVM PoA — проверяется в We·R2 Chain explorer.' },
        accountAbstraction: { title: 'Абстракция аккаунтов', desc: 'Onboarding без трения для не-крипто пользователей через account abstraction.' },
        governance: { title: 'Управление', desc: 'Токен BGT + 151 Sovereign Nodes со 117,616 WR2 застейканных на узел.' },
        realWorld: { title: 'Реальный мир', desc: 'RWA on-chain с Freedom Homes Club — токенизация недвижимости под DMCC Dubai.' },
        community: { title: 'Активное сообщество', desc: '35,000+ в waitlist · экосистема с Blonect, We·R2 Finance, We·R2 Pay и др.' },
      }
    },
    top10: {
      headline: "Топ 10 Стратегических dApps на We·R2 Chain – Критический Приоритет",
      subtext: "Приложения, необходимые для роста экосистемы, оцениваются техкомитетом We·R2. Гранты в WR2 Coin.",
      applyBtn: "Подать заявку на разработку",
      impact: "Ожидаемое воздействие",
      priority: "Приоритет",
      incentive: "Модель стимулирования",
      status: "Статус"
    },
    top20: {
      headline: "Стратегические Разработки Экосистемы We·R2",
      subtext: "dApps высокого воздействия открыты для предложений. Оценка техкомитета We·R2 Ecosystem.",
      applyBtn: "Подать заявку"
    },
    openProposals: {
      headline: "Предложите Свою dApp на We·R2 Chain",
      description: "Есть идея, соответствующая суверенному видению We·R2 Ecosystem? Отправьте предложение на рассмотрение техкомитету We·R2. Лучшие проекты получают гранты в WR2 Coin и доступ к 151 Sovereign Nodes.",
      cta: "Отправить Предложение"
    },
    form: {
      headline: "Заявка Разработчика",
      teamInfo: "Информация о Команде",
      teamName: "Название Команды",
      country: "Страна",
      website: "Веб-сайт",
      github: "GitHub",
      linkedin: "LinkedIn",
      previousProjects: "Предыдущие Web3 Проекты",
      selectedDapp: "Выбранная dApp",
      selectPlaceholder: "Выберите dApp или Пользовательское Предложение",
      customProposal: "Пользовательское Предложение",
      techArchitecture: "Техническая Архитектура",
      smartContract: "Дизайн Смарт-Контракта",
      scalability: "Стратегия Масштабирования",
      securityPlan: "План Безопасности",
      techStack: "Технологический Стек",
      timeline: "Сроки",
      mvp: "Дата MVP",
      beta: "Дата Beta",
      mainnet: "Дата Mainnet",
      incentivePref: "Предпочтение Стимулирования",
      grant: "Грант",
      revenueShare: "Распределение Доходов",
      hybrid: "Гибрид",
      strategic: "Стратегическое Партнерство",
      whyUni2: "Почему We·R2 Chain?",
      fileUpload: "Загрузить Whitepaper или Презентацию",
      submit: "Отправить Заявку Разработчика",
      submitting: "Отправка...",
      success: "Заявка успешно отправлена!",
      error: "Ошибка при отправке заявки"
    },
    dashboard: {
      headline: "Трекер Развития Экосистемы",
      inReview: "На Рассмотрении",
      approved: "Одобрено",
      inDevelopment: "В Разработке",
      live: "Запущено",
      total: "Всего Проектов"
    },
    admin: {
      login: "Вход Админа",
      password: "Пароль",
      loginBtn: "Войти",
      logout: "Выйти",
      proposals: "Предложения",
      updateStatus: "Обновить Статус",
      viewDetails: "Подробности"
    },
    categories: {
      gaming: "Игры и Вовлечение",
      social: "Социальная Инфраструктура",
      defi: "DeFi Инфраструктура",
      lending: "Кредитование",
      payments: "Платежи",
      nft: "NFT Утилита",
      gamification: "Геймификация",
      governance: "Управление",
      security: "Безопасность",
      rwa: "Реальные Активы",
      ai: "ИИ и ML",
      staking: "Стейкинг",
      payroll: "Зарплата",
      crosschain: "Кросс-чейн",
      data: "Данные",
      insurance: "Страхование",
      creator: "Экономика Создателей",
      loyalty: "Лояльность",
      oracle: "Оракул",
      analytics: "Аналитика",
      nocode: "Без Кода",
      launchpad: "Лаунчпад",
      bridge: "Мост",
      carbon: "Углеродные Кредиты",
      supply: "Цепочка Поставок",
      invoice: "Счета",
      dao: "DAO"
    },
    statuses: {
      open: "Открыто для предложений",
      review: "На рассмотрении",
      approved: "Одобрено",
      development: "В разработке",
      live: "Запущено"
    },
    incentives: {
      grant: "Грант (WR2 Coin)",
      revenueShare: "Распределение доходов",
      grantRevenue: "Грант + Распределение",
      strategic: "Стратегическое партнерство"
    },
    hackathons: {
      title: "Хакатоны",
      subtitle: "Участвуйте в наших хакатонах и боритесь за призы в WR2 Coin, строя на We·R2 Chain",
      upcoming: "Предстоящие",
      active: "Активные",
      completed: "Завершенные",
      registerNow: "Зарегистрироваться",
      viewDetails: "Подробности",
      prizes: "Призы",
      tracks: "Треки",
      participants: "Участники",
      deadline: "Срок регистрации",
      startDate: "Дата начала",
      endDate: "Дата окончания",
      requirements: "Требования",
      registration: "Регистрация на хакатон",
      teamName: "Название команды",
      teamMembers: "Члены команды",
      memberName: "Имя",
      memberRole: "Роль",
      memberGithub: "GitHub",
      addMember: "Добавить члена",
      selectTrack: "Выбрать трек",
      projectIdea: "Идея проекта",
      contactEmail: "Контактный email",
      registerTeam: "Зарегистрировать команду",
      registrationSuccess: "Успешно зарегистрированы!",
      registrationError: "Ошибка регистрации",
      statusUpcoming: "Предстоящий",
      statusOpen: "Регистрация открыта",
      statusActive: "Активный",
      statusJudging: "Оценка",
      statusCompleted: "Завершенный"
    },
    score: {
      title: "Builder Score",
      breakdown: "Разбор оценки",
      teamInfo: "Команда",
      techArchitecture: "Архитектура",
      timeline: "Сроки",
      whyUni2: "Почему We·R2",
      projectSelection: "Выбор проекта",
      high: "Высокий приоритет",
      medium: "Средний приоритет",
      low: "Низкий приоритет"
    },
    nda: {
      generate: "Сгенерировать NDA",
      download: "Скачать NDA",
      generated: "NDA создан"
    },
    footer: {
      tagline: "Building the next generation of dApps on We·R2 Chain — EVM PoA, Chain ID 111888, DMCC Licensed."
    },
    sovereign: {
      headline: "Sovereign Nodes",
      subtext: "Опора We·R2 Chain — 151 распределённый валидатор, каждый стейкает 117,616 WR2 Coin. Вместе они управляют BGT предложениями и защищают сеть.",
      stat_nodes: "Sovereign Nodes",
      stat_stake: "WR2 застейкано на узел",
      stat_consensus: "Консенсус",
      consensus: "EVM PoA",
      learnMore: "Узнать больше о Sovereign Nodes"
    }
  },
  ur: {
    nav: {
      home: "ہوم",
      top10: "ٹاپ 10 dApps",
      top20: "ترجیحی dApps",
      sovereignNodes: "Sovereign Nodes",
      apply: "درخواست دیں",
      dashboard: "ڈیش بورڈ",
      admin: "ایڈمن"
    },
    hero: {
      badge: "We·R2 Builders Program — کھلا",
      headline: "We·R2 Chain پر dApps کی اگلی نسل بنائیں",
      subheadline: "We·R2 Builders Program میں شامل ہوں اور ایکو سسٹم کی ترجیحی dApps میں سے ایک تیار کریں۔ WR2 Coin میں گرانٹس، ریونیو شیئر ماڈلز، We·R2 Chain کی تکنیکی مدد اور طویل مدتی شراکت داری حاصل کریں۔",
      cta_top10: "ٹاپ 10 اسٹریٹجک dApps دیکھیں",
      cta_proposal: "تجویز جمع کرائیں",
      cta_partner: "ڈیولپمنٹ پارٹنر کے طور پر درخواست دیں",
      cta_nodes: "Sovereign Nodes دیکھیں",
      stat_dapps: "اسٹریٹجک dApps",
      stat_grants: "WR2 گرانٹس میں"
    },
    whyBuild: {
      headline: "We·R2 Chain پر کیوں بنائیں؟",
      intro: "خود مختار بلاک چین انفراسٹرکچر، EVM-مطابق، 6,980 TPS اور DMCC لائسنس یافتہ۔",
      features: {
        lowCost: { title: 'کم لین دین کی لاگت', desc: 'WR2 Coin میں گیس فیس — PoA کی بدولت Ethereum mainnet سے کافی سستا۔' },
        scalability: { title: 'اعلی اسکیل ایبلٹی', desc: '6,980 TPS · 6s/block · Chain ID 111888 · EVM PoA — We·R2 Chain explorer پر قابل تصدیق۔' },
        accountAbstraction: { title: 'اکاؤنٹ ایبسٹریکشن', desc: 'غیر کرپٹو صارفین کے لیے بغیر رکاوٹ onboarding۔' },
        governance: { title: 'گورننس', desc: 'BGT ٹوکن + 151 Sovereign Nodes فی نوڈ 117,616 WR2 staked۔' },
        realWorld: { title: 'حقیقی دنیا کا انضمام', desc: 'Freedom Homes Club کے ساتھ on-chain RWA — DMCC دبئی کے تحت۔' },
        community: { title: 'فعال کمیونٹی', desc: '35,000+ early adopters · Blonect، We·R2 Finance، We·R2 Pay وغیرہ کے ساتھ بڑھتا ایکو سسٹم۔' },
      }
    },
    top10: {
      headline: "We·R2 Chain پر ٹاپ 10 اسٹریٹجک dApps – اہم ترجیح",
      subtext: "ایکو سسٹم کی ترقی کے لیے ضروری ایپلیکیشنز، We·R2 تکنیکی کمیٹی کے ذریعے جانچ۔ گرانٹس WR2 Coin میں۔",
      applyBtn: "بنانے کے لیے درخواست دیں",
      impact: "متوقع اثر",
      priority: "ترجیح",
      incentive: "ترغیبی ماڈل",
      status: "حیثیت"
    },
    top20: {
      headline: "We·R2 ایکو سسٹم کی اسٹریٹجک ترقیات",
      subtext: "بلڈر تجاویز کے لیے کھلی اعلی اثر dApps۔ We·R2 Ecosystem تکنیکی کمیٹی کی جانچ۔",
      applyBtn: "درخواست دیں"
    },
    openProposals: {
      headline: "We·R2 Chain پر اپنی dApp تجویز کریں",
      description: "کیا آپ کے پاس کوئی خیال ہے جو We·R2 Ecosystem کے خود مختار وژن سے میل کھاتا ہے؟ We·R2 تکنیکی کمیٹی کے جائزے کے لیے اپنی تجویز جمع کرائیں۔ بہترین پروجیکٹس WR2 Coin میں گرانٹس اور 151 Sovereign Nodes تک رسائی حاصل کرتے ہیں۔",
      cta: "تجویز جمع کرائیں"
    },
    form: {
      headline: "بلڈر درخواست",
      teamInfo: "ٹیم کی معلومات",
      teamName: "ٹیم کا نام",
      country: "ملک",
      website: "ویب سائٹ",
      github: "GitHub",
      linkedin: "LinkedIn",
      previousProjects: "پچھلے Web3 پروجیکٹس",
      selectedDapp: "منتخب dApp",
      selectPlaceholder: "dApp یا اپنی مرضی کی تجویز منتخب کریں",
      customProposal: "اپنی مرضی کی تجویز",
      techArchitecture: "تکنیکی فن تعمیر",
      smartContract: "سمارٹ کنٹریکٹ ڈیزائن",
      scalability: "اسکیل ایبلٹی حکمت عملی",
      securityPlan: "سیکیورٹی پلان",
      techStack: "ٹیک اسٹیک",
      timeline: "ٹائم لائن",
      mvp: "MVP تاریخ",
      beta: "بیٹا تاریخ",
      mainnet: "مین نیٹ تاریخ",
      incentivePref: "ترغیبی ترجیح",
      grant: "گرانٹ",
      revenueShare: "ریونیو شیئر",
      hybrid: "ہائبرڈ",
      strategic: "اسٹریٹجک پارٹنرشپ",
      whyUni2: "We·R2 Chain کیوں؟",
      fileUpload: "وائٹ پیپر یا ڈیک اپ لوڈ کریں",
      submit: "بلڈر درخواست جمع کرائیں",
      submitting: "جمع ہو رہا ہے...",
      success: "درخواست کامیابی سے جمع ہو گئی!",
      error: "درخواست جمع کرانے میں خرابی"
    },
    dashboard: {
      headline: "ایکو سسٹم ڈیولپمنٹ ٹریکر",
      inReview: "جائزے میں",
      approved: "منظور شدہ",
      inDevelopment: "ترقی میں",
      live: "لائیو",
      total: "کل پروجیکٹس"
    },
    admin: {
      login: "ایڈمن لاگ ان",
      password: "پاس ورڈ",
      loginBtn: "لاگ ان",
      logout: "لاگ آؤٹ",
      proposals: "تجاویز",
      updateStatus: "حیثیت اپ ڈیٹ کریں",
      viewDetails: "تفصیلات دیکھیں"
    },
    categories: {
      gaming: "گیمنگ اور انگیجمنٹ",
      social: "سماجی انفراسٹرکچر",
      defi: "DeFi انفراسٹرکچر",
      lending: "قرض دینا",
      payments: "ادائیگیاں",
      nft: "NFT یوٹیلٹی",
      gamification: "گیمیفیکیشن",
      governance: "گورننس",
      security: "سیکیورٹی",
      rwa: "حقیقی دنیا کے اثاثے",
      ai: "AI اور ML",
      staking: "اسٹیکنگ",
      payroll: "پے رول",
      crosschain: "کراس چین",
      data: "ڈیٹا",
      insurance: "انشورنس",
      creator: "کریٹر اکانومی",
      loyalty: "وفاداری",
      oracle: "اوریکل",
      analytics: "تجزیات",
      nocode: "نو کوڈ",
      launchpad: "لانچ پیڈ",
      bridge: "برج",
      carbon: "کاربن کریڈٹس",
      supply: "سپلائی چین",
      invoice: "انوائس",
      dao: "DAO"
    },
    statuses: {
      open: "تجاویز کے لیے کھلا",
      review: "جائزے میں",
      approved: "منظور شدہ",
      development: "ترقی میں",
      live: "لائیو"
    },
    incentives: {
      grant: "گرانٹ (WR2 Coin)",
      revenueShare: "ریونیو شیئر",
      grantRevenue: "گرانٹ + ریونیو شیئر",
      strategic: "اسٹریٹجک پارٹنرشپ"
    },
    footer: {
      tagline: "Building the next generation of dApps on We·R2 Chain — EVM PoA, Chain ID 111888, DMCC Licensed."
    },
    sovereign: {
      headline: "Sovereign Nodes",
      subtext: "We·R2 Chain کی ریڑھ کی ہڈی — 151 تقسیم شدہ ویلیڈیٹرز، ہر ایک 117,616 WR2 Coin staked۔ مل کر BGT تجاویز کو منظم اور نیٹ ورک کو محفوظ بناتے ہیں۔",
      stat_nodes: "Sovereign Nodes",
      stat_stake: "WR2 فی نوڈ staked",
      stat_consensus: "اتفاق رائے",
      consensus: "EVM PoA",
      learnMore: "Sovereign Nodes کے بارے میں مزید جانیں"
    }
  },
  hi: {
    nav: {
      home: "होम",
      top10: "टॉप 10 dApps",
      top20: "पसंदीदा dApps",
      sovereignNodes: "Sovereign Nodes",
      apply: "आवेदन करें",
      dashboard: "डैशबोर्ड",
      admin: "एडमिन"
    },
    hero: {
      badge: "We·R2 Builders Program — खुला",
      headline: "We·R2 Chain पर dApps की अगली पीढ़ी बनाएं",
      subheadline: "We·R2 Builders Program में शामिल हों और इकोसिस्टम के प्राथमिकता वाले dApps में से एक विकसित करें। WR2 Coin में अनुदान, राजस्व साझा मॉडल, We·R2 Chain का तकनीकी समर्थन और दीर्घकालिक सह-निर्माण तक पहुंच प्राप्त करें।",
      cta_top10: "टॉप 10 रणनीतिक dApps देखें",
      cta_proposal: "प्रस्ताव जमा करें",
      cta_partner: "विकास भागीदार के रूप में आवेदन करें",
      cta_nodes: "Sovereign Nodes देखें",
      stat_dapps: "रणनीतिक dApps",
      stat_grants: "WR2 अनुदान में"
    },
    whyBuild: {
      headline: "We·R2 Chain पर क्यों बनाएं?",
      intro: "संप्रभु ब्लॉकचेन इंफ्रास्ट्रक्चर, EVM-संगत, 6,980 TPS और DMCC लाइसेंस प्राप्त।",
      features: {
        lowCost: { title: 'कम लेनदेन लागत', desc: 'WR2 Coin में गैस फीस — PoA की वजह से Ethereum mainnet से काफी सस्ता।' },
        scalability: { title: 'उच्च स्केलेबिलिटी', desc: '6,980 TPS · 6s/ब्लॉक · Chain ID 111888 · EVM PoA — We·R2 Chain explorer पर सत्यापन योग्य।' },
        accountAbstraction: { title: 'अकाउंट एब्स्ट्रैक्शन', desc: 'गैर-क्रिप्टो उपयोगकर्ताओं के लिए सहज onboarding।' },
        governance: { title: 'गवर्नेंस', desc: 'BGT टोकन + 151 Sovereign Nodes, प्रति नोड 117,616 WR2 staked।' },
        realWorld: { title: 'वास्तविक दुनिया का एकीकरण', desc: 'Freedom Homes Club के साथ on-chain RWA — DMCC दुबई के तहत।' },
        community: { title: 'सक्रिय समुदाय', desc: '35,000+ early adopters · Blonect, We·R2 Finance, We·R2 Pay के साथ बढ़ता इकोसिस्टम।' },
      }
    },
    top10: {
      headline: "We·R2 Chain पर टॉप 10 रणनीतिक dApps – महत्वपूर्ण प्राथमिकता",
      subtext: "इकोसिस्टम वृद्धि के लिए आवश्यक एप्लिकेशन, We·R2 तकनीकी समिति द्वारा मूल्यांकित। अनुदान WR2 Coin में।",
      applyBtn: "बनाने के लिए आवेदन करें",
      impact: "अपेक्षित प्रभाव",
      priority: "प्राथमिकता",
      incentive: "प्रोत्साहन मॉडल",
      status: "स्थिति"
    },
    top20: {
      headline: "We·R2 इकोसिस्टम के रणनीतिक विकास",
      subtext: "बिल्डर प्रस्तावों के लिए खुले उच्च-प्रभाव dApps। We·R2 Ecosystem तकनीकी समिति का मूल्यांकन।",
      applyBtn: "आवेदन करें"
    },
    openProposals: {
      headline: "We·R2 Chain पर अपनी dApp प्रस्तावित करें",
      description: "क्या आपके पास We·R2 Ecosystem के संप्रभु विजन से मेल खाने वाला विचार है? We·R2 तकनीकी समिति द्वारा समीक्षा के लिए अपना प्रस्ताव जमा करें। सर्वश्रेष्ठ प्रोजेक्ट WR2 Coin में अनुदान और 151 Sovereign Nodes तक पहुंच प्राप्त करते हैं।",
      cta: "प्रस्ताव जमा करें"
    },
    form: {
      headline: "बिल्डर आवेदन",
      teamInfo: "टीम जानकारी",
      teamName: "टीम का नाम",
      country: "देश",
      website: "वेबसाइट",
      github: "GitHub",
      linkedin: "LinkedIn",
      previousProjects: "पिछले Web3 प्रोजेक्ट्स",
      selectedDapp: "चयनित dApp",
      selectPlaceholder: "dApp या कस्टम प्रस्ताव चुनें",
      customProposal: "कस्टम प्रस्ताव",
      techArchitecture: "तकनीकी वास्तुकला",
      smartContract: "स्मार्ट कॉन्ट्रैक्ट डिजाइन",
      scalability: "स्केलेबिलिटी रणनीति",
      securityPlan: "सुरक्षा योजना",
      techStack: "टेक स्टैक",
      timeline: "समयरेखा",
      mvp: "MVP तारीख",
      beta: "बीटा तारीख",
      mainnet: "मेननेट तारीख",
      incentivePref: "प्रोत्साहन वरीयता",
      grant: "अनुदान",
      revenueShare: "राजस्व साझा",
      hybrid: "हाइब्रिड",
      strategic: "रणनीतिक साझेदारी",
      whyUni2: "We·R2 Chain क्यों?",
      fileUpload: "व्हाइटपेपर या डेक अपलोड करें",
      submit: "बिल्डर आवेदन जमा करें",
      submitting: "जमा हो रहा है...",
      success: "आवेदन सफलतापूर्वक जमा!",
      error: "आवेदन जमा करने में त्रुटि"
    },
    dashboard: {
      headline: "इकोसिस्टम विकास ट्रैकर",
      inReview: "समीक्षा में",
      approved: "स्वीकृत",
      inDevelopment: "विकास में",
      live: "लाइव",
      total: "कुल प्रोजेक्ट्स"
    },
    admin: {
      login: "एडमिन लॉगिन",
      password: "पासवर्ड",
      loginBtn: "लॉगिन",
      logout: "लॉगआउट",
      proposals: "प्रस्ताव",
      updateStatus: "स्थिति अपडेट करें",
      viewDetails: "विवरण देखें"
    },
    categories: {
      gaming: "गेमिंग और एंगेजमेंट",
      social: "सामाजिक इंफ्रास्ट्रक्चर",
      defi: "DeFi इंफ्रास्ट्रक्चर",
      lending: "उधार",
      payments: "भुगतान",
      nft: "NFT उपयोगिता",
      gamification: "गेमिफिकेशन",
      governance: "गवर्नेंस",
      security: "सुरक्षा",
      rwa: "वास्तविक विश्व संपत्ति",
      ai: "AI और ML",
      staking: "स्टेकिंग",
      payroll: "पेरोल",
      crosschain: "क्रॉस-चेन",
      data: "डेटा",
      insurance: "बीमा",
      creator: "क्रिएटर इकोनॉमी",
      loyalty: "लॉयल्टी",
      oracle: "ओरेकल",
      analytics: "एनालिटिक्स",
      nocode: "नो-कोड",
      launchpad: "लॉन्चपैड",
      bridge: "ब्रिज",
      carbon: "कार्बन क्रेडिट",
      supply: "सप्लाई चेन",
      invoice: "इनवॉइस",
      dao: "DAO"
    },
    statuses: {
      open: "प्रस्तावों के लिए खुला",
      review: "समीक्षा में",
      approved: "स्वीकृत",
      development: "विकास में",
      live: "लाइव"
    },
    incentives: {
      grant: "अनुदान (WR2 Coin)",
      revenueShare: "राजस्व साझा",
      grantRevenue: "अनुदान + राजस्व साझा",
      strategic: "रणनीतिक साझेदारी"
    },
    footer: {
      tagline: "Building the next generation of dApps on We·R2 Chain — EVM PoA, Chain ID 111888, DMCC Licensed."
    },
    sovereign: {
      headline: "Sovereign Nodes",
      subtext: "We·R2 Chain की रीढ़ — 151 वितरित वैलिडेटर्स, प्रत्येक 117,616 WR2 Coin स्टेक करता है। साथ मिलकर BGT प्रस्तावों का संचालन और नेटवर्क की सुरक्षा करते हैं।",
      stat_nodes: "Sovereign Nodes",
      stat_stake: "WR2 प्रति नोड staked",
      stat_consensus: "सहमति",
      consensus: "EVM PoA",
      learnMore: "Sovereign Nodes के बारे में और जानें"
    }
  }
};

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let result = translations[lang];
  for (const k of keys) {
    if (result && result[k]) {
      result = result[k];
    } else {
      // Fallback to English
      result = translations['en'];
      for (const kFallback of keys) {
        if (result && result[kFallback]) {
          result = result[kFallback];
        } else {
          return key;
        }
      }
      return result;
    }
  }
  return result;
};
